export const PaginationSettings = {
  PAGE_SIZES: [15, 25, 50, 75, 100],
  DEFAULT_CURRENT_PAGE: 1,
  DEFAULT_CURRENT_PAGE_SIZE: 15,
};
